/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:34:41 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-29 21:18:41
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class UserService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/users`;

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  createUser(data) {
    return this.http.post(`${this.url}`, data);
  }

  getUsers(page: number, role: string, sort: string, search?: string) {
    return this.http.get(`${this.url}?page=${page}&role=${role}&sort=${sort}&s=${search}&lang=${this.transService.lang}`);
  }

  getUser(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateUser(id: string, data) {
    return this.http.put(`${this.url}/${id}?lang=${this.transService.lang}`, data);
  }

  deleteUser(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  sendPush(id: string, message: string) {
    return this.http.put(`${this.url}/${id}/push?lang=${this.transService.lang}`, {
      message: message
    });
  }

  addStripeInfo(id: string, data) {
    return this.http.put(`${this.url}/${id}/stripe?lang=${this.transService.lang}`, data);
  }

  removeStripeInfo(id: string, stripeId) {
    return this.http.delete(`${this.url}/${id}/stripe/${stripeId}?lang=${this.transService.lang}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts